export default __webpack_public_path__ + "static/media/guiaWindows3.acdd16c2.png";